// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import _ from 'lodash';

import 'rc-slider/assets/index.css';
import './App.css';

import Header from './components/Header.js';
import Progress from './components/Progress';
import Box from './components/Box';

import renderHTML from 'react-render-html';

import QuestionHandler from './components/questions/_QuestionHandler';

import { Questions, type StateType } from './assets/model';
import { log } from 'util';

type Props = {
  state: StateType
};

type State = {};

class App extends React.Component<Props, State> {
  render(): React.Node {
    const { currentQuestion, progress } = this.props.state;

    return (
      <div className="App">
        <Progress progress={progress} />
        <Header title={renderHTML(Questions[currentQuestion].question)} />

        <QuestionHandler />
      </div>
    );
  }
}

export default connect(state => ({ state }))(App);



// WEBPACK FOOTER //
// ./src/App.js